import React, { useEffect, useLayoutEffect, useState } from "react";
import { HashRouter, useLocation } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import Login from "./components/login/login";
import DashBoard from "./components/dashboard/Dashboard";
import ProtectedRoute from "./protected";
import BarcodeReader from "./pages/2dbarcodereader"

import Logout from "./components/login/logout";
import ProductDetail from "./pages/productDetail";
import AllNotifications from "./components/notification/allNotifications";
import ProductListing from "./components/card/productListing";
import StorageCountSummary from "./pages/storageCountSummary";
import useOnlineStatus from "./useOnlineStatus";
import { getAllProductOffline, initPushAccountProduct, initPushInmates, initPushLogs, initPushProduct } from "./offlineManager/inventoryOffline";
import { add, addToCollection } from "./offlineManager/localbase";
import { ApiUrls, TENANT_SEARCH_NEW_FOR_SHIBBO } from "./api/baseURL";
import { post, updateLogger } from "./api/api";
import LocationWisePage from "./components/dashboard/locationWisePage";
import AccountWisePage from "./components/dashboard/accountWisePage";
import AccountBarcodeReader from "./pages/accountwise/accountwise2dbarcodereader";
import AccountWiseProductDetail from "./pages/accountwise/accountWiseProductDetail";
import AccountWiseProductLising from "./pages/accountwise/accountWiseInventoryRecords";
import Loader from "./components/loader/loader";
import axios from "axios";
import InmateScanForm from "./components/dashboard/inmateScanPage";
import InmateScanGrid from "./pages/inmate/inmateScanGrid";
import InmateScanReport from "./components/dashboard/inmateScanReport";
import { getOfflineFeatures, getPhysicalInventoryCheckOffline, getPreviousQuantity } from "./utils/utils";
import { useFeature } from "./hooks/useFeature";
import InmateScanningPage from "./components/dashboard/inmateScanningPage";

const App = () => {
  const isAuthenticated = localStorage.getItem("token") ? true : false;
  let accessToken = undefined;
  let firstName;
  let lastName;
  let userId;
  let userName;
  let mail;
  let tenantName;

  const [activateLoader, setActivateLoader] = useState(false);

  useEffect(() => {
    console.log(isAuthenticated);
    const window_url = window.location.href;
    // for gettong the values of token and all details from address bar 
    if (window_url?.split("#")[1] !== undefined) {
      accessToken = window_url?.split("#")[1]?.split("/")[1]?.split("?=")[1];
      mail = window_url?.split("#")[1]?.split("/")[2]?.split("?=")[1];
      firstName = window_url?.split("#")[1]?.split("/")[3]?.split("?=")[1];
      lastName = window_url?.split("#")[1]?.split("/")[4]?.split("?=")[1];
      userName = window_url?.split("#")[1]?.split("/")[5]?.split("?=")[1];
      userId = window_url?.split("#")[1]?.split("/")[6]?.split("?=")[1];
      tenantName = window_url?.split("#")[1]?.split("/")[7]?.split("?=")[1] || "RIT";
    }
    if (accessToken !== undefined) {
      localStorage.setItem("token", accessToken);
      localStorage.setItem("userID", userId);
      localStorage.setItem("userName", userName);
      localStorage.setItem("lastName", lastName);
      localStorage.setItem("firstName", firstName);
      localStorage.setItem("email", mail);
      localStorage.setItem("tenantName", tenantName);
      // localStorage.setItem('timeoutTimestamp', Date.now().toString());
      axios.get(TENANT_SEARCH_NEW_FOR_SHIBBO + `?TenantName=${tenantName}`).then((res) => {
        
        const tenantData = JSON.parse(res?.data?.result)
        localStorage.setItem("base-url", tenantData.CSWCF + '/')
        
          
        const payload ={"domainName":"fulcrumww.com","clientName":"suite","applicationTokenName":"Web","applicationName": "demo","multiTenant": tenantName}
        //  const payload = {"domainName":"fulcrumww.com","clientName":"suite","applicationTokenName":"Web","applicationName":"live","multiTenant":"RIT"}
        
        axios.post(ApiUrls().SERVICE_TOKEN, payload, { headers: {"Content-Type": "application/json"}}).then(response => {
          if (response?.status === 200) {
            localStorage.setItem("applicationTenantLinkId", response?.data.serviceToken.applicationTenantLinkId);
            localStorage.setItem("applicationKey", response?.data.serviceToken.applicationKey);
            localStorage.setItem("tenantKey", response?.data.serviceToken.tenantKey);
            localStorage.setItem("tokenId", response?.data.serviceToken.tokenId);
            localStorage.setItem("tokenKey", response?.data.serviceToken.tokenKey);
          }
        }).catch(err => {
          updateLogger(err, 1);
          window.location.href = `#/*`;
        })
        
      }).catch(err => {
        console.log("error", err)
        updateLogger(err, 1);
        window.location.href = `#/*`;
      })

    }
  }, []);

  let token;
  const isOnline = useOnlineStatus();
  useEffect(() => {
    setTimeout(async () => {

      if (isAuthenticated) {
        // checking for push data to Db from indexed DB 
        if (isOnline) {
          initPushProduct();
          initPushAccountProduct();
          initPushInmates();
          initPushLogs();
        }
        const isOnlineSync = localStorage.getItem("isOnlineSync")
        const isOnlineSyncAccount = localStorage.getItem("isOnlineSyncAccount")
        if (isOnline && isOnlineSync == 1) {
          localStorage.setItem("isOnlineSync", 0)
          setActivateLoader(true);
          // updating previous Quantity data in indexed DB 
          getPreviousQuantity().then(res => setActivateLoader(false)).catch(err => setActivateLoader(false))
        }
        if (isOnline && isOnlineSyncAccount == 1) {
          localStorage.setItem("isOnlineSyncAccount", 0)
          setActivateLoader(true);
          // updating previous Quantity data in indexed DB 
          getPhysicalInventoryCheckOffline().then(res => setActivateLoader(false)).catch(err => setActivateLoader(false))
        }
      }
    }, 3000);
  }, [isOnline])


  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute >
                <DashBoard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/inventory_records"
            element={
              <ProtectedRoute >
                <ProductListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account_wise_inventory_records"
            element={
              <ProtectedRoute >
                <AccountWiseProductLising />
              </ProtectedRoute>
            }
          />

          <Route
            path="/storage_count_summary"
            element={
              <ProtectedRoute >
                <StorageCountSummary />
              </ProtectedRoute>
            }
          />


          <Route
            path="/2d_barcode_scanner"
            element={
              <ProtectedRoute >
                <BarcodeReader />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account_barcode_scanner"
            element={
              <ProtectedRoute >
                < AccountBarcodeReader />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account_product_detail"
            element={
              <ProtectedRoute >
                < AccountWiseProductDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inmate_scan_grid"
            element={
              <ProtectedRoute >
                < InmateScanGrid />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inmate_scan_form"
            element={
              <ProtectedRoute >
                <InmateScanForm />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inmate_scan_report"
            element={
              <ProtectedRoute >
                <InmateScanReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/account_wise_inventory"
            element={
              <ProtectedRoute >
                <AccountWisePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/location_wise_inventory"
            element={
              <ProtectedRoute >
                <LocationWisePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inmate_scanning"
            element={
              <ProtectedRoute >
                <InmateScanningPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product_detail"
            element={
              <ProtectedRoute >
                <ProductDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all_notifications"
            element={
              <ProtectedRoute >
                < AllNotifications />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={<div> Not Found or You do not have permission.</div>}
          />
        </Routes>
      </HashRouter>
      <Loader active={activateLoader} />
    </>
  );
};
export default App;
